
const LoginOptions = ({children}) => {
    return(
        <div className="w-full flex flex-col items-center justify-start space-y-3">
            {children}
        </div>
    );
}

export default LoginOptions;